import { AxiosPromise } from "axios";
import { CONSTANT_CONFIG } from "../../constants";
import { HttpService } from "../../services/http.services";

const RESOURCE_ENDPOINT = `${CONSTANT_CONFIG.TRAINING_SERVER_PREFIX}/training-dashboard`;
const endpoints = {
    getOrganogramWiseDashboardData: () => `${RESOURCE_ENDPOINT}/organogram-wise-data`,
}

export default class AdminDashboardApi {

  public getOrganogramWiseDashboardData = (params = {}, headers = {}): AxiosPromise<any> => {
    const url = endpoints.getOrganogramWiseDashboardData();
    return HttpService.get(url, params, headers);
  }


}
